import type { Action } from 'state/actions';
import {
  BatchWorkspaceShortcutCheatsheetBannerState,
  initialBatchWorkspaceShortcutCheatsheetBannerState,
} from 'state/workspaces/batch/shortcutCheatsheetBanner/shortcutCheatsheetBanner.model';
export function batchWorkspaceShortcutCheatsheetBannerReducer(
  state: BatchWorkspaceShortcutCheatsheetBannerState = initialBatchWorkspaceShortcutCheatsheetBannerState,
  action: Action,
): BatchWorkspaceShortcutCheatsheetBannerState {
  switch (action.type) {
    case 'NEW_BATCH_WORKSPACE_SHORTCUT_CHEATSHEET_BANNER_CLOSED':
      return { ...state, IsCheatsheetBannerClosed: true };
    default:
      return state;
  }
}
